import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, onMounted, Ref, ref } from "vue";
import { Portal } from "portal-vue";
import CiUspComponent from "@components/base/capinside-usp.vue";
import CiSuggestedExternalContent from "@components/ads/suggested-external-content.vue";
import ComparisonsCarousel from "@components/start/comparisons-carousel.vue";
import Event from "@components/start/event.vue";
import FundSearch from "@components/start/fund-search.vue";
import LoggedInBanner from "@components/start/logged-in-banner.vue";
import News from "@components/start/news.vue";
import Notifications from "@components/start/notifications.vue";
import PartnerCarousel from "@components/start/partner-carousel.vue";
import PartnerProducts from "@components/start/partner-products.vue";
import PortfoliosCarousel from "@components/start/portfolios-carousel.vue";
import ProductsTabs from "@components/start/products-tabs.vue";
import WatchlistCarousel from "@components/start/watchlist-carousel.vue";
import { useInternalTracking } from "@composables/internalTracking";
import { apiService } from "@services/api.service";
import { ciTrackingService } from "@services/ci-tracking.service";
import { viewportService } from "@services/viewport.service";
import { CurrentUser } from "@utils/user";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["tracking-click"],
  setup(__props, { emit }: { emit: ({ (event: "tracking-click", options: InternalTracking.TrackClickOptions): void }), expose: any, slots: any, attrs: any }) {

const currentTab = ref(0);
const viewMode: "news" | "products" = "news";
const partner: Ref<Nullable<Companies.Tile>> = ref(null);
const comparisonsLoading = ref(true);
const comparisons = ref<Comparisons.Details.Instance[]>([]);
const comparisonsCount = ref(0);
const newsLoading = ref(true);
const startPageContents = ref<Indexable>({});
const companiesLoading = ref(true);
const partnerCompanies = ref<Companies.Tile[]>([]);
const portfoliosLoading = ref(true);
const portfolios = ref<Portfolios.TileData[]>([]);
const portfoliosCount = ref(0);
const watchlistLoading = ref(true);
const watchlistProducts = ref<Products.Followed.TileData[]>([]);
const watchlistProductsCount = ref(0);
const partnerProductsLoading = ref(true);
const partnerProducts = ref<Products.TileData[]>([]);
const eventLoading = ref(true);
const event = ref<Nullable<Events.Event>>(null);


const { propagateTrackClick } = useInternalTracking(emit, "StartPage");

const loadPartner = async () => {
  const response = await apiService.companies.partnerTeaser();
  partner.value = response.data;
};

const loadWatchlist = async () => {
  const watchlistResponse = await apiService.products.followedProducts({ period: "1_year", per_page: 3 });
  watchlistProducts.value = watchlistResponse.data.products;
  watchlistProductsCount.value = watchlistResponse.data.meta.total_count;
  watchlistLoading.value = false;
};

const loadComparisons = async () => {
  const comparisonsResponse = await apiService.comparisons.all({ per_page: 3 });
  comparisons.value = comparisonsResponse.data.comparisons;
  comparisonsCount.value = comparisonsResponse.data.meta.total_count;
  comparisonsLoading.value = false;
};

const loadPortfolios = async () => {
  const portfoliosResponse = await apiService.portfolios.all({ per_page: 3 });
  portfolios.value = portfoliosResponse.data.portfolios;
  portfoliosCount.value = portfoliosResponse.data.meta.total_count;
  portfoliosLoading.value = false;
};

const loadNews = async () => {
  const startPageContentsResponse = await apiService.contents.getStartPageContents();
  startPageContents.value = startPageContentsResponse.data;
  newsLoading.value = false;
};

const loadPartnerCompanies = async () => {
  const partnerCompaniesResponse = await apiService.companies.premiumPartners();
  partnerCompanies.value = partnerCompaniesResponse.data.company_profiles;
  companiesLoading.value = false;
};

const loadPartnerProducts = async () => {
  const partnerProductsResponse = await apiService.products.all("partner");
  partnerProducts.value = partnerProductsResponse.data.products;
  partnerProductsLoading.value = false;
};

const loadEvent = async () => {
  apiService.social_events
    .featured()
    .then((eventResponse) => (event.value = eventResponse.data.social_event))
    .catch((err) => {
      if (err.response.status !== 404) apiService.handleAPIError(err);
    })
    .finally(() => (eventLoading.value = false));
};

onBeforeMount(async () => {
  const loaders = [loadNews(), loadPartnerCompanies(), loadPartnerProducts()];
  if (CurrentUser.signedIn) {
    loaders.push(loadPartner(), loadWatchlist(), loadComparisons(), loadPortfolios(), loadEvent());
  }
  try {
    await Promise.all(loaders);
  } catch (e) {
    apiService.handleAPIError(e);
  } finally {
    watchlistLoading.value = comparisonsLoading.value = portfoliosLoading.value = false;
  }
});

onMounted(async () => {
  await ciTrackingService.trackView("StartPage");
});

return { __sfc: true,currentTab, viewMode, partner, comparisonsLoading, comparisons, comparisonsCount, newsLoading, startPageContents, companiesLoading, partnerCompanies, portfoliosLoading, portfolios, portfoliosCount, watchlistLoading, watchlistProducts, watchlistProductsCount, partnerProductsLoading, partnerProducts, eventLoading, event, emit, propagateTrackClick, loadPartner, loadWatchlist, loadComparisons, loadPortfolios, loadNews, loadPartnerCompanies, loadPartnerProducts, loadEvent, Portal, CiUspComponent, CiSuggestedExternalContent, ComparisonsCarousel, Event, FundSearch, LoggedInBanner, News, Notifications, PartnerCarousel, PartnerProducts, PortfoliosCarousel, ProductsTabs, WatchlistCarousel, viewportService, CurrentUser }
}

})